import { Button } from "@skilitics/designer-ui-components";

import type { AspectType } from "./types";
import { useSelectedAspect } from "./useSelectedAspect";
import { useSetSelectedNodeId } from "./useSelectedNode";

type Props = {
  nodeId: number;
  selectedAspect?: AspectType;
  buttonLabel: string;
};

export const SelectNodeButton = ({ buttonLabel, nodeId, selectedAspect = "properties" }: Props) => {
  const setSelectedNodeId = useSetSelectedNodeId();
  const [_, setSelectedAspect] = useSelectedAspect();

  const handleClick = () => {
    setSelectedNodeId(nodeId);
    setSelectedAspect(selectedAspect);
  };

  return (
    <Button onClick={handleClick} variant="outlined" size="small">
      {buttonLabel}
    </Button>
  );
};
